module.exports = __webpack_public_path__ + "img/the-factory-bloc-4x6.be2597a1.jpg";